import React, { ReactNode } from 'react';
import { Tab } from '@headlessui/react';
import styles from './tabGroup.module.css';
import classNames from 'classnames';

export const IW_TabGroup = ({
    tabs,
    panels,
    className
}: {
    tabs: ReactNode;
    panels: ReactNode;
    className: string;
}) => {
    return (
        <Tab.Group as="div" className={className}>
            <Tab.List className={styles.tabList}>{tabs}</Tab.List>
            <Tab.Panels className={styles.panels}>{panels}</Tab.Panels>
        </Tab.Group>
    );
};

export const IW_Tab = ({
    children,
    disabled,
    className
}: {
    children: ReactNode;
    disabled?: boolean;
    className?: string;
}) => {
    return (
        <Tab disabled={disabled} className={classNames(styles.tab, className)}>
            {children}
        </Tab>
    );
};

export const IW_TabPanel = ({
    children,
    className
}: {
    children: ReactNode;
    className?: string;
}) => {
    return <Tab.Panel className={className}>{children}</Tab.Panel>;
};
